import * as React from 'react';
import { styles } from './styles';
import { cx } from 'emotion';

interface Props {}

const ModalContent: React.SFC<Props> = ({ children }) => {
  const classNames = cx('modal__content', styles.container);
  return <div className={classNames}>{children}</div>;
};

export { ModalContent };
